import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { label: "Proposte", href: "#proposte" },
  { label: "Servizi", href: "#servizi" },
  { label: "Chi Siamo", href: "#chi-siamo" },
  { label: "Contatti", href: "#contatti" },
];

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="logo-link" className={`flex flex-col leading-none ${className}`}>
    <span className="font-script text-3xl md:text-4xl text-[#FFF200] drop-shadow-[2px_2px_0_rgba(0,0,0,0.6)]">
      Cardillo Viaggi
    </span>
    <span className="text-[9px] md:text-[10px] tracking-[0.25em] uppercase text-white/70 font-medium mt-0.5">
      Agenzia Viaggi &amp; Noleggio Autobus
    </span>
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-sm text-white/80 hover:text-[#FFF200] transition-colors duration-200 font-medium"
            >
              {l.label}
            </button>
          ))}
          <a
            href="tel:+393463710318"
            data-testid="nav-call"
            className="flex items-center gap-2 bg-[#FFF200] text-black text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-[#FFF200]/90 transition-colors duration-200"
          >
            <Phone size={15} /> +39 346 3710318
          </a>
        </nav>

        <button
          className="md:hidden text-white"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-left text-white/80 hover:text-[#FFF200] transition-colors py-1"
            >
              {l.label}
            </button>
          ))}
          <a
            href="tel:+393463710318"
            className="flex items-center gap-2 bg-[#FFF200] text-black font-semibold px-5 py-3 rounded-full justify-center mt-2"
          >
            <Phone size={16} /> Chiama ora
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
